import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function PainPoints() {
  const pains = ['You spend too much time searching for exercises or inventing sequences at the last minute', "You don't have a clear progression by fitness level and end up repeating the same things every week", 'You arrive at your sessions without a fluid structure and explanations that take too long', 'You have no serious library of functional and cross training protocols to pull from without starting from scratch', 'When the week gets complicated, your planning falls apart and you improvise too much', "You want to look more prepared and professional — but without a ready system you waste hours you don't have"];
  return <section className="py-12 md:py-24 px-4 bg-brand-dark relative border-t border-zinc-800/50" data-id="element-107">
      <div className="max-w-4xl mx-auto" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-16" data-id="element-109">
          <h2 className="text-2xl md:text-5xl font-bold mb-4 md:mb-6 leading-tight" data-id="element-110">
            IF EVERY WEEK YOU LOSE HOURS ORGANIZING YOUR SESSIONS,{' '}
            <span className="text-brand-orange" data-id="element-111">THIS WILL SOUND FAMILIAR:</span>
          </h2>
        </motion.div>

        <div className="grid gap-3 md:gap-6 mb-10 md:mb-16" data-id="element-112">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-3 md:gap-4 p-4 md:p-6 rounded-xl bg-zinc-900/50 border border-zinc-800/50 hover:border-brand-orange/30 transition-colors" data-id="element-113">
              <XCircle className="w-5 h-5 md:w-6 md:h-6 text-brand-orange shrink-0 mt-0.5 md:mt-1" data-id="element-114" />
              <p className="text-base md:text-lg text-zinc-300 leading-relaxed" data-id="element-115">
                {pain}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="p-6 md:p-12 rounded-2xl bg-gradient-to-br from-brand-blue/20 to-transparent border border-brand-blue/30 text-center relative overflow-hidden" data-id="element-116">
          <div className="absolute top-0 right-0 w-32 h-32 md:w-64 md:h-64 bg-brand-blue/10 blur-[50px] md:blur-[100px] rounded-full" data-id="element-117"></div>
          <h3 className="text-xl md:text-4xl font-bold mb-3 md:mb-4 text-white relative z-10" data-id="element-118">
            THE COMPLETE SYSTEM
          </h3>
          <p className="text-base md:text-xl text-zinc-300 max-w-2xl mx-auto relative z-10" data-id="element-119">
            Six comprehensive volumes — over 600 pages of pure coaching content
            — with everything you need to prepare faster, coach better and
            arrive at every session completely ready.
          </p>
        </motion.div>
      </div>
    </section>;
}